export interface CustomEOD {
  hours: number;
  minutes: number;
  /** Optional IANA timezone. Absent/undefined = Local Time (browser). */
  timezone?: string;
}

function normalizeTimePart(value: string | number | undefined): number {
  const normalized = Number(value);
  return Number.isNaN(normalized) ? 0 : normalized;
}

export function normalizeCustomEOD(customEOD: {
  hours?: string | number;
  minutes?: string | number;
  timezone?: string;
}): CustomEOD {
  const normalized: CustomEOD = {
    hours: normalizeTimePart(customEOD.hours),
    minutes: normalizeTimePart(customEOD.minutes),
  };

  if (typeof customEOD.timezone === 'string' && customEOD.timezone.length > 0) {
    normalized.timezone = customEOD.timezone;
  }

  return normalized;
}
